const projects = [
    {
        id: 1,
        name: "Live Meet",
        subtitle: "Integrating Jitsi in E-Learning application",
        image: [
            "https://naufalhakim.my.id/uploads/livemeet.png",
        ],
        description: "Implementsai dari Jitsi API ke dalam E-Learning Web App, menggunakan JavaScript dan PHP.",
        link: "",
        source: "",
        tech: [
            "JavaScript",
            "PHP"
        ]
    },
    {
        id: 2,
        name: "Kreass",
        subtitle: "Event landing page",
        image: [
            "https://naufalhakim.my.id/uploads/kreass.png",
        ],
        description: "Responsive landing page untuk sebuah event, berisi tentang informasi event dan lomba yang ada.",
        link: "https://kreass.manh21.com",
        source: "https://github.com/manh21/Kreass-11",
        tech: [
            "JavaScript",
            "Sass"
        ]
    },
    {
        id: 3,
        name: "Web Profile MPK",
        subtitle: "Web Profile dan Blog CMS",
        image: [
            "https://naufalhakim.my.id/uploads/mpk1.png",
            "https://naufalhakim.my.id/uploads/mpk2.png",
            "https://naufalhakim.my.id/uploads/mpk3.png",
        ],
        description: "Dibuat dengan menggukana framework Codeigniter3 sebagai backend, froentend menggunakan html/css/javascript.",
        link: "https://mpk.manh21.com",
        source: "",
        tech: [
            "CodeIgniter",
            "JavaScript"
        ]
    },
    {
        id: 4,
        name: "Web Profile OSMASASKH",
        subtitle: "Web Profile, Blog CMS, Laporan Keuangan",
        image: [
            "https://naufalhakim.my.id/uploads/osmasaskh1.png",
            "https://naufalhakim.my.id/uploads/osmasaskh2.png",
            "https://naufalhakim.my.id/uploads/osmasaskh3.png",
            "https://naufalhakim.my.id/uploads/osmasaskh4.png",
        ],
        description: "Di web ini terdapat sistem laporan keuangan/akutansi untuk transparansi anggaran dan terdapar Blog CMS. Dibuat dengan menggukana framework Codeigniter3 sebagai backend, froentend menggunakan html/css/javascript.",
        link: "https://osmasaskh.manh21.com",
        source: "",
        tech: [
            "CodeIgniter",
            "JavaScript",
            "Sass",
        ]
    },
    {
        id: 5,
        name: "E-Voting",
        subtitle: "Voting pemilihan umum",
        image: [
            "https://naufalhakim.my.id/uploads/evoting.jpg",
            "https://naufalhakim.my.id/uploads/evoting2.jpg",
            "https://naufalhakim.my.id/uploads/evoting3.jpg",
            "https://naufalhakim.my.id/uploads/evoting4.jpg",
            "https://naufalhakim.my.id/uploads/evoting5.jpg",
            "https://naufalhakim.my.id/uploads/evoting6.jpg",
            "https://naufalhakim.my.id/uploads/evoting7.jpg",
        ],
        description: "Memanfaatkan teknologi untuk pemungutan suara. Dibuat dengan menggukana framework Codeigniter3 sebagai backend, froentend menggunakan html/css/javascript.",
        link: "",
        source: "https://github.com/manh21/eVoting",
        tech: [
            "CodeIgniter",
            "JavaScript",
        ]
    },
    {
        id: 6,
        name: "My Club",
        subtitle: "Progresive Web App",
        image: [
            "https://naufalhakim.my.id/uploads/myclub1.png",
        ],
        description: "Mengkonsumsi api dari football-data.org app yang berfungsi untuk cek jadwal pertandingan club bola. dibuat dengan JavaScript, HTML, CSS yang memanfaatkan indexedDB, LocalStorage, Cache API",
        link: "https://dicoding-footballapp.web.app",
        source: "https://github.com/manh21/dicoding/tree/master/Submission%203%20MPWA",
        tech: [
            "JavaScript",
        ]
    },
    {
        id: 7,
        name: "Gacha",
        subtitle: "Progresive Web App",
        image: [
            "https://naufalhakim.my.id/uploads/gacha.png",
        ],
        description: "Aplikasi tentang informasi kekuatan karakter dari Genshin Impact. dibuat dengan JavaScript, HTML, CSS",
        link: "https://gacha-pwa.web.app",
        source: "https://github.com/manh21/dicoding/tree/master/Gacha",
        tech: [
            "JavaScript",
        ]
    },
    {
        id: 8,
        name: "Moviein",
        subtitle: "Single Page Application",
        image: [
            "https://naufalhakim.my.id/uploads/moviein.png",
        ],
        description: "Web untuk mencari film menggunakan API dari themoviedb.org. dibuat dengan JavaScript, HTML, CSS, Webpack, NodeJs, Axios",
        link: "https://naufalhakim.my.id/moviein",
        source: "https://github.com/manh21/dicoding/tree/master/Fundamental%20frontend",
        tech: [
            "JavaScript",
            "Webpack",
            "NodeJS",
            "Axios"
        ]
    },
    {
        id: 9,
        name: "Club Finder",
        subtitle: "Single Page Application",
        image: [
            "https://naufalhakim.my.id/uploads/clubfinder.png",
        ],
        description: "Web untuk mencari club bola menggunakan API dari thesportsdb.org. dibuat dengan JavaScript, HTML, CSS, Webpack, NodeJs, Axios",
        link: "https://naufalhakim.my.id/clubfinder",
        source: "https://github.com/manh21/dicoding/tree/master/ClubFinder",
        tech: [
            "JavaScript",
            "Webpack",
            "NodeJS",
        ]
    },
];

export default projects;